var map = {
	"./decidim/avatar-multiuser.png": 50262,
	"./decidim/brands/facebook.svg": 84992,
	"./decidim/brands/google.svg": 31769,
	"./decidim/brands/twitter-x.svg": 16562,
	"./decidim/cc-badge.png": 84680,
	"./decidim/decidim-logo.svg": 212,
	"./decidim/default-avatar.svg": 50092,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 13272,
	"./decidim/icons.svg": 54823,
	"./decidim/pattern.png": 99336,
	"./decidim/placeholder-card-g.svg": 87373,
	"./decidim/placeholder-card-l.svg": 39366,
	"./decidim/placeholder.jpg": 41029,
	"./decidim/remixicon.symbol.svg": 48745,
	"./decidim/vendor/social-share-button/douban.svg": 33864,
	"./decidim/vendor/social-share-button/email.svg": 3141,
	"./decidim/vendor/social-share-button/facebook.svg": 45819,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 80085,
	"./decidim/vendor/social-share-button/hacker_news.svg": 43573,
	"./decidim/vendor/social-share-button/linkedin.svg": 77245,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 11470,
	"./decidim/vendor/social-share-button/pinterest.svg": 84379,
	"./decidim/vendor/social-share-button/reddit.svg": 36111,
	"./decidim/vendor/social-share-button/telegram.svg": 82114,
	"./decidim/vendor/social-share-button/tumblr.svg": 47009,
	"./decidim/vendor/social-share-button/twitter.svg": 52724,
	"./decidim/vendor/social-share-button/vkontakte.svg": 61258,
	"./decidim/vendor/social-share-button/wechat.svg": 21813,
	"./decidim/vendor/social-share-button/whatsapp.svg": 2757,
	"./decidim/vendor/social-share-button/x.svg": 69157,
	"./decidim/vendor/social-share-button/xing.svg": 28443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43897;